import { combineReducers } from "redux";
import live from "./Live";

export default combineReducers({ live });
